const FolderIcon = () => {
  return (
    <svg className="folder-icon" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.9719 6.2C6.9719 6.37239 6.90898 6.53772 6.79698 6.65962C6.68499 6.78152 6.53309 6.85 6.37471 6.85H1.59719C1.43881 6.85 1.28691 6.78152 1.17491 6.65962C1.06292 6.53772 1 6.37239 1 6.2V1.65C1 1.47761 1.06292 1.31228 1.17491 1.19038C1.28691 1.06848 1.43881 1 1.59719 1H3.09016L3.68735 1.975H6.37471C6.53309 1.975 6.68499 2.04348 6.79698 2.16538C6.90898 2.28728 6.9719 2.45261 6.9719 2.625V6.2Z" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default FolderIcon